export default __webpack_public_path__ + "b6b888ef1f24a7668ccef675aab03504.png";